/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Rule_ReviewInputs */

const en_directory_vibebids_rule_review = /** @type {(inputs: Directory_Vibebids_Rule_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every product is reviewed before it appears.`)
};

const zh_directory_vibebids_rule_review = /** @type {(inputs: Directory_Vibebids_Rule_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个产品都会经过审核后才会显示。`)
};

/**
* | output |
* | --- |
* | "Every product is reviewed before it appears." |
*
* @param {Directory_Vibebids_Rule_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_rule_review = /** @type {((inputs?: Directory_Vibebids_Rule_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Rule_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_rule_review(inputs)
	return zh_directory_vibebids_rule_review(inputs)
});
export { directory_vibebids_rule_review as "directory.vibebids.rule_review" }